import { Routes, Route } from "react-router-dom";
import { Ispovesti } from "./pages/Ispovesti/Ispovesti";
import { Home } from "./pages/Home/Home";

export const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ispovesti" element={<Ispovesti />} />
      </Routes>
    </>
  );
};
